import { render } from "./StoricoCliente.vue?vue&type=template&id=5e93a108&ts=true"
import script from "./StoricoCliente.vue?vue&type=script&lang=ts"
export * from "./StoricoCliente.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__